module.exports = __webpack_public_path__ + "img/6.86c60b28.webp";